import React from 'react';
export function ProductSection() {
  return <section className="py-20 px-5 bg-cream text-center reveal pt-[30px] pb-[30px]" data-id="element-231">
      <p className="font-lora text-base text-text-mid max-w-[500px] mx-auto mb-10 leading-relaxed italic" data-id="element-232">
        No es un PDF suelto. Es un sistema integrado que te dice exactamente qué
        hacer cada día.
      </p>

      <div className="max-w-[640px] mx-auto mb-12 bg-forest rounded-2xl py-9 px-8 relative overflow-hidden" data-id="element-233">
        <div className="absolute -top-10 -right-10 w-[200px] h-[200px] bg-[radial-gradient(circle,rgba(255,255,255,0.06)_0%,transparent_70%)]" data-id="element-234" />

        <div className="inline-block bg-terracotta text-white text-[0.65rem] tracking-[0.12em] uppercase py-1.5 px-3.5 rounded-sm mb-4 font-semibold" data-id="element-235">
          El programa
        </div>
        <div className="font-playfair text-[clamp(1.8rem,4vw,2.8rem)] font-black text-cream leading-[1.15] mb-3" data-id="element-236">
          Programa de
          <br data-id="element-237" />
          <em className="italic text-gold" data-id="element-238">Activación Lectora</em>
        </div>
        <div className="font-lora text-[0.95rem] text-cream/75 italic leading-[1.6]" data-id="element-239">
          Sistema estructurado · 21 días · 10 minutos por día
        </div>
      </div>

      <div className="max-w-[480px] mx-auto mb-10 rounded-2xl overflow-hidden shadow-[0_24px_80px_rgba(30,45,36,0.15)]" data-id="element-240">
        <img src="https://cdn.magicpatterns.com/uploads/hx98aDrmMusRukghj8U9n8/mockup_verdadero_2.png" alt="Mockup del Programa de Activación Lectora" className="w-full block" data-id="element-241" />
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3 max-w-[680px] mx-auto mb-4" data-id="element-242">
        <div className="bg-white border border-forest/10 rounded-lg py-3.5 px-4 flex items-center gap-3 text-[0.85rem] text-text-dark text-left" data-id="element-243">
          <span className="text-[1.1rem] shrink-0" data-id="element-244">📘</span> Manual para Padres
          (Paso a paso)
        </div>
        <div className="bg-white border border-forest/10 rounded-lg py-3.5 px-4 flex items-center gap-3 text-[0.85rem] text-text-dark text-left" data-id="element-245">
          <span className="text-[1.1rem] shrink-0" data-id="element-246">📅</span> Plan de Acción de
          21 Días
        </div>
        <div className="bg-white border border-forest/10 rounded-lg py-3.5 px-4 flex items-center gap-3 text-[0.85rem] text-text-dark text-left" data-id="element-247">
          <span className="text-[1.1rem] shrink-0" data-id="element-248">✏️</span> Workbook imprimible
          de actividades
        </div>
        <div className="bg-white border border-forest/10 rounded-lg py-3.5 px-4 flex items-center gap-3 text-[0.85rem] text-text-dark text-left" data-id="element-249">
          <span className="text-[1.1rem] shrink-0" data-id="element-250">✅</span> Checklist de
          progreso diario
        </div>
        <div className="bg-white border border-forest/10 rounded-lg py-3.5 px-4 flex items-center gap-3 text-[0.85rem] text-text-dark text-left sm:col-span-2 md:col-span-1" data-id="element-251">
          <span className="text-[1.1rem] shrink-0" data-id="element-252">🛡️</span> Guía Anti
          Frustración
        </div>
      </div>

      <div className="max-w-[680px] mx-auto bg-cream-dark rounded-lg py-3 px-5 text-[0.8rem] text-text-mid flex items-center justify-center gap-5 flex-wrap mt-4" data-id="element-253">
        <span className="flex items-center gap-1.5" data-id="element-254">📱 100% digital</span>
        <span className="flex items-center gap-1.5" data-id="element-255">
          📧 Acceso inmediato por email
        </span>
        <span className="flex items-center gap-1.5" data-id="element-256">
          📱 Funciona desde el celular
        </span>
        <span className="flex items-center gap-1.5" data-id="element-257">
          🖨️ Materiales imprimibles incluidos
        </span>
      </div>
    </section>;
}